const ENDPOINT = process.env.NODE_ENV === 'development'
    ? "http://localhost:9000/api"
    : window.location.origin + "/api";

const api = async (method: string, url: string, body: any, options?: RequestInit) => {
    return new Promise((resolve, reject) => {
        fetch(ENDPOINT + url, {
            method: method,
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body),
            ...options
        }).then((response) => {
            if (!response.ok) {
                reject("Network response was not ok. Error: " + response.statusText);
            }

            response.json().then((deserialized) => {
                    if (!deserialized.success)
                        reject("API error: " + deserialized.error);

                    resolve(deserialized);
                }
            );
        }).catch(error => {
            reject("Network error: " + error);
        })
    });
}

export const Api = {
    hello: async () => {
        return api("GET", "/hello", {hello: "world"})
    },
    login: async (userId: string) => {
        return api("POST", "/login", {userId})
    },
    // logout not needed, handled by session storage
    getUserData: async (userId: string) => {
        return api("POST", "/getUserData", {userId}).then((response: any) => {
            if (response.data === undefined) {
                return null;
            }
            return JSON.parse(response.data);
        });
    },
    getGroupData: async (userId: string) => {
        return api("POST", "/getGroupData", {userId}).then((response: any) => {
            if (response.data === undefined) {
                return null;
            }
            return response.data;
        });
    },
    getGlobalData: async (userId: string) => {
        return api("POST", "/getGlobalData", {userId}).then((response: any) => {
            if (response.data === undefined) {
                return null;
            }
            return response.data;
        });
    },
    writeUserData: async (userId: string, data: any) => {
        return api("POST", "/writeUserData", {userId, data})
    }
}